import React from 'react';
import Recoil from 'recoil';
import focusElement from 'utils/focusElement';
import hotkey from 'utils/hotkey';

export default function useTabFocus() {
  React.useEffect(() => {
    const forward = hotkey(['Tab']);
    const backward = hotkey(['Shift+Tab']);
    const onKeyDown = (e) => {
      forward(e, () => {
        e.preventDefault();
        e.stopPropagation();
        focusElement(document.activeElement, 1);
      });
      backward(e, () => {
        e.preventDefault();
        e.stopPropagation();
        focusElement(document.activeElement, -1);
      })
    };
    window.addEventListener('keydown', onKeyDown);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, []);
}
